import React from 'react'

import { Button, FormGroup, Label, Col, Input } from 'reactstrap'
import { ButtonGroupCustom } from '@/components/Layout'
import Icon from '@/components/Icon'
import LanguageName from '@/components/LanguageName'
import DocumentationAttachments from './attachments'
import { Validator } from '@/components/validation'
import { ITEM_TYPES } from '@/constants'

class ItemForm extends React.Component {
  isDocumentType () { return this.props.item.itemType === ITEM_TYPES.DOCUMENT }
  validateTitle ({ value }) {
    if (value && value.trim().length === 0) {
      return 'Validations.CannotConsistJustOfBlankCharacters'
    }
  }
  renderComponentsForLanguage (language) {
    const attachment = (this.props.item.file || {})[language]
    const existingAttachments = (attachment ? [attachment] : [])
    return (
      <React.Fragment>
        <Label sm={1}><LanguageName localize={this.props.localize} locale={language} />: </Label>
        <Col sm={5}>
          <div>
            <Validator name={`title_${language}`} onValidate={this.validateTitle} value={this.props.item.title[language]} required>
              <Input type='text'
                className='form-control'
                placeholder={this.props.localize('Documentation.EnterTitleHere')}
                value={this.props.item.title[language]}
                onChange={(e) => this.props.onTitleChange(language, e.target.value)} />
            </Validator>
          </div>
          <DocumentationAttachments
            isVisible={this.isDocumentType()}
            attachments={existingAttachments}
            downloadAction={this.props.downloadAction}
            onAttachmentChange={e => this.props.onAttachmentChange(language, e)} />
        </Col>
      </React.Fragment>
    )
  }
  render () {
    const { localize } = this.props
    return (
      <React.Fragment>
        <FormGroup row>
          <Col sm={{ size: 11, offset: 1 }}>
            <ButtonGroupCustom>
              <Button onClick={() => this.props.onItemTypeChange(ITEM_TYPES.CHAPTER)} active={!this.isDocumentType()}><Icon name='folder' /> <span>{localize('Documentation.Chapter')}</span></Button>
              <Button onClick={() => this.props.onItemTypeChange(ITEM_TYPES.DOCUMENT)} active={this.isDocumentType()}><Icon name='file-blank' /> <span>{localize('Documentation.Document')}</span></Button>
            </ButtonGroupCustom>
          </Col>
        </FormGroup>

        <div className='item-titles'>
          <FormGroup row>
            {this.renderComponentsForLanguage('en')}
            {this.renderComponentsForLanguage('ar')}
          </FormGroup>
        </div>
      </React.Fragment>
    )
  }
}

export default ItemForm



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/documentation/itemForm.js